import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { StepBar, StepLabel, StepsRow, Wrapper, } from './styles';
function ProgressBar({ steps, currentStep, stepLabel }) {
    const label = stepLabel ?? `Step ${currentStep} of ${steps}`;
    return (_jsxs(Wrapper, { children: [_jsx(StepsRow, { children: Array.from({ length: steps }, (_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                _jsx(StepBar, { complete: index < currentStep }, index))) }), _jsx(StepLabel, { children: label })] }));
}
ProgressBar.defaultProps = {
    stepLabel: undefined,
};
export default ProgressBar;
